var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.951 138.674L41.5814 128.339L34.145 35.2871H115.857L108.413 128.324L74.951 138.674V138.674Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.039 122.399L108.401 42.8945H75.0005V130.762L102.039 122.399V122.399Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1915 77.4075L52.1082 88.8199H74.9998V77.4075H51.1915ZM49.3491 54.3086L50.279 65.721H74.9998V54.3086H49.3491V54.3086ZM74.9998 107.047L74.9549 107.06L63.5625 103.628L62.8341 94.5262H52.5653L53.9983 112.445L74.9527 118.935L74.9998 118.92V107.047Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.376 9.99927H65.7652V15.7796H58.5572V21.56H65.7659V27.3399H53.376V9.99927ZM68.2434 9.99927H80.633V15.0256H73.4246V16.0308H80.633V27.5915H68.2437V22.3132H75.4521V21.308H68.2431V9.99927H68.2434ZM83.1111 9.99927H95.5007V15.0256H88.2923V16.0308H95.5007V27.5915H83.1111V22.3132H90.3195V21.308H83.1114V9.99927H83.1111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7438 77.4075L100.59 54.3086H74.9657V65.721H89.3798L88.449 77.4075H74.9657V88.8198H87.5621L86.3745 103.621L74.9653 107.056V118.929L95.9364 112.445L96.0901 110.517L98.4943 80.472L98.7438 77.4075V77.4075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 129,
    fill: "white",
    transform: "translate(34 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/Css.1b86f1783d7248a0f926b2e595cffa38.svg";
export { ForwardRef as ReactComponent };